import * as React from "react";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl, useSelector } from "@grandvisionhq/state";
import { DeliveryIndicatorModalContainer } from "./DeliveryIndicatorModal.js";
import { getPreferredShippingMethod } from "../../../../../../state/state/selectors.js";
import { useGetDeliveryEstimationMessage } from "../../../../../../hooks/hooks/use-get-delivery-estimation-message.js";
import { DeliveryIndicator } from "../../../../components/modules/DeliveryIndicator/components/DeliveryIndicator.js";
import { useDeliveryIndicator } from "../../../../../../contexts/DeliveryIndicator/contexts/DeliveryIndicator/context.js";
const DeliveryIndicatorFullDateContainer = ({
  items,
  fallbackLabel,
  view = "full",
  hasRxLens,
  ...rest
}) => {
  const { getLabel } = useIntl();
  const { deliveryInfo } = useDeliveryIndicator();
  const preferredShippingMethod = useSelector(getPreferredShippingMethod);
  const { deliveryMessage, loading, error } = useGetDeliveryEstimationMessage(
    items ?? [],
    preferredShippingMethod,
    hasRxLens
  );
  const tooltipSlot = deliveryInfo ? /* @__PURE__ */ React.createElement(DeliveryIndicatorModalContainer, null) : /* @__PURE__ */ React.createElement(Toggletip, { message: getLabel("products.deliveryIndicator.deliveryTooltip") });
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      deliveryMessage,
      isLoading: loading,
      hasError: !!error,
      view,
      fallbackLabel,
      tooltipSlot,
      ...rest
    }
  );
};
export {
  DeliveryIndicatorFullDateContainer
};
//# sourceMappingURL=DeliveryIndicatorFullDate.js.map
